
import Bezier from "../../../assets/outline/Bezier.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function BezierIcon({ className, dataTestid = "BezierIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Bezier data-testid={dataTestid} className={classes} {...rest} />
  );
}
